<template lang="pug">
.receive-packet-container(@touchmove.prevent)
  .now-money-container
    Lottie.lottie(
      key="bcg_lottie",
      url="https://m.hellobike.com/resource/helloyun/08345/s2xRY_111.json"
    )
    .task-block
      .top-block
        span 再{{couponInfo.jumpButtonDesc}}
        span.red-word {{couponInfo.goToFinishNum}}次
        span 领
        span {{couponInfo.subtitle}}哦
      .middle-block
        .middle-red
          .packet-price-num {{couponInfo.amount}}
          .packet-price-yuan(v-if="couponInfo.unit") {{couponInfo.unit}}
        .middle-word {{couponInfo.businessLineName}}{{couponInfo.propType!==4?"券":"卡"}}
      .packet-receive-button(@click="goToUse") {{couponInfo.jumpButtonDesc}}
    .receive-packet-close(@click="closeModal")
      img.close(src="https://m.hellobike.com/resource/helloyun/08345/KyfI3xjHl3.png")
    .shadow
  </template>

<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Navigator } from '@hb/h5-navigator';
import { desc, getName } from '../utils.js';

export default {
  components: {
    Lottie,
  },
  props: {
    couponInfo: {
      type: Object,
      required: true,
    },
  },
  mounted() {
  },
  methods: {
    desc,
    getName,
    closeModal() {
      this.$emit('update:show', false);
    },
    goToUse() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_task_pop',
        categoryId: 'platform',
        businessInfo: {
          businessType: this.couponInfo.businessLineName,
        },
      });
      Navigator.go(this.couponInfo.appJumpUrl);
      this.$emit('update:show', false);
    },

  },
};
</script>
<style lang="less" scoped>
.receive-packet-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;

  .lottie {
    z-index: 101;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .now-money-container {
    margin-top: 1.92rem;

    .task-block {
      background-size: 100% 100%;
      margin: 0 auto;
      z-index: 101;
      position: relative;

      .top-block {
        padding-top: 0.08rem;
        height: 0.48rem;
        background-image: url('https://m.hellobike.com/resource/helloyun/08345/o7SB3_Slice%201.png?x-oss-process=image/quality,q_80');
        background-size: 100% 100%;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.22rem;
        font-weight: 600;
        line-height: 0.31rem;
        text-align: center;
        color: #ffe5c0;

        .red-word {
          color: #ff5526;
        }
      }

      .middle-block {
        margin: 0.34rem auto;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/cYdjRiTZeE.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        width: 1.54rem;
        height: 1.74rem;

        .middle-red {
          display: flex;
          justify-content: center;

          .packet-price-num {
            height: 0.74rem;
            font-size: 0.55rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            color: #f54311;
            line-height: 0.64rem;
            font-weight: 700;
            margin-top: 0.276rem;
          }

          .packet-price-yuan {
            margin: 0 0 0.08rem 0.02rem;
            width: 0.22rem;
            height: 0.3rem;
            font-size: 0.22rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 400;
            color: #fa4614;
            line-height: 0.22rem;
            margin-top: 0.586rem;
          }
        }

        .middle-word {
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-size: 20px;
          font-weight: 500;
          line-height: 28px;
          text-align: center;
          color: #fff3d0;
          margin-top: 0.3rem;
        }
      }

      .packet-receive-button {
        text-align: center;
        margin: 0.1rem auto 0 auto;
        width: 2.24rem;
        height: 0.54rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/WfgPs9UoGm.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 600;
        color: #531900;
        line-height: 0.54rem;
      }
    }

    .receive-packet-close {
      margin-top: 0.37rem;
      display: flex;
      justify-content: center;
      z-index: 101;
      position: relative;

      .close {
        width: 0.3rem;
        height: 0.3rem;
        z-index: 101;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
